import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ClientsApi = createApi({
  reducerPath: "ClientsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    fetchClients: builder.query({
      query: (lang) => ({
        url: "clients",
        headers: {
          lang: lang,
        },
      }),
      staleTime: 1000 * 60 * 5,
    }),
  }),
});

export const { useFetchClientsQuery } = ClientsApi;
